/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import Link from "next/link";
import { useEffect } from "react";
import Navigation from "../components/Navigation";
import RandomBackground from "../components/RandomBackground";
import FeatureHighlightsStrip from "../components/FeatureHighlightsStrip";

// Shopify configuration from .NET app
const SHOPIFY_CONFIG = {
  domain: "rain-block.myshopify.com",
  storefrontAccessToken: "dc2f40b15bd7a8f3778b07f05e514061",
  products: [{
    id: 2195074023542,
    containerId: "product-component-1"
  }, {
    id: 8857366214,
    containerId: "product-component-2"
  }]
};

// Shopify Buy Button options - updated for gel-400 theme
const productOptions = {
  product: {
    layout: "horizontal",
    variantId: "all",
    width: "100%",
    contents: {
      img: false,
      imgWithCarousel: true,
      variantTitle: false,
      description: true,
      buttonWithQuantity: true,
      button: false,
      quantity: false
    },
    styles: {
      product: {
        "@media (min-width: 601px)": {
          "max-width": "100%",
          "margin-left": "0",
          "margin-bottom": "50px"
        }
      },
      img: {
        "border-radius": "12px"
      },
      title: {
        "font-size": "22px",
        color: "#ffffff"
      },
      price: {
        "font-size": "24px",
        color: "#5fd0ff",
        fontWeight: "bold"
      },
      compareAt: {
        "font-size": "14px",
        color: "#9ca3af"
      },
      description: {
        color: "#d1d5db"
      },
      button: {
        "background-color": "#5fd0ff",
        color: "#0a0e27",
        ":hover": {
          "background-color": "#4fb8e8"
        },
        "border-radius": "8px",
        padding: "12px 24px"
      },
      quantity: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityInput: {
        color: "#000000",
        background: "#ffffff",
        "background-color": "#ffffff",
        "border-color": "#2a3150"
      },
      quantityIncrement: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityDecrement: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      }
    }
  },
  cart: {
    contents: {
      button: true
    },
    styles: {
      button: {
        "background-color": "#5fd0ff",
        color: "#0a0e27",
        ":hover": {
          "background-color": "#4fb8e8"
        },
        "border-radius": "8px"
      },
      footer: {
        "background-color": "#0f1229"
      },
      cart: {
        "background-color": "#0a0e27"
      },
      title: {
        color: "#ffffff"
      },
      lineItems: {
        color: "#ffffff"
      },
      quantity: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        background: "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityInput: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        background: "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityIncrement: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityDecrement: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      subtotalText: {
        color: "#ffffff"
      },
      subtotal: {
        color: "#5fd0ff"
      },
      notice: {
        color: "#9ca3af"
      },
      close: {
        color: "#ffffff",
        ":hover": {
          color: "#9ca3af"
        }
      }
    }
  },
  lineItem: {
    styles: {
      quantity: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityInput: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityIncrement: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityDecrement: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      }
    }
  },
  toggle: {
    styles: {
      toggle: {
        "background-color": "#5fd0ff",
        ":hover": {
          "background-color": "#4fb8e8"
        }
      },
      count: {
        color: "#0a0e27"
      }
    }
  },
  modalProduct: {
    contents: {
      img: false,
      imgWithCarousel: true,
      variantTitle: false,
      buttonWithQuantity: true,
      button: false,
      quantity: false
    },
    styles: {
      product: {
        "@media (min-width: 601px)": {
          "max-width": "100%",
          "margin-left": "0px",
          "margin-bottom": "0px"
        }
      },
      quantity: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityInput: {
        color: "#000000",
        background: "#ffffff",
        "background-color": "#ffffff",
        "border-color": "#2a3150"
      },
      quantityIncrement: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      },
      quantityDecrement: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150"
      }
    }
  },
  productSet: {
    styles: {
      products: {
        "@media (min-width: 601px)": {
          "margin-left": "10px"
        }
      }
    }
  }
};
declare global {
  interface Window {
    ShopifyBuy: unknown;
  }
}
export default function Shop() {
  const $ = _c(49);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp4, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const productsSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: [{
        "@type": "ListItem",
        position: 1,
        item: {
          "@type": "Product",
          "@id": "https://rainblock.net/shop#single-pack",
          name: "Rain Block\xAE Single Pack",
          image: "https://rainblock.net/kitframe3.jpg",
          description: "Single Rain Block\xAE waterproof extension cord connector cover for outdoor electrical connections",
          brand: {
            "@type": "Brand",
            name: "Rain Block\xAE"
          },
          offers: {
            "@type": "Offer",
            url: "https://rainblock.net/shop",
            priceCurrency: "USD",
            price: "24.99",
            availability: "https://schema.org/InStock",
            itemCondition: "https://schema.org/NewCondition"
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4.8",
            reviewCount: "350"
          }
        }
      }, {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "Product",
          "@id": "https://rainblock.net/shop#ultimate-protection-kit",
          name: "Rain Block\xAE Ultimate Protection Kit",
          image: "https://rainblock.net/kitframe3.jpg",
          description: "Complete weatherproof extension cord cover kit with multiple Rain Block\xAE connector gaskets for whole-home outdoor electrical protection",
          brand: {
            "@type": "Brand",
            name: "Rain Block\xAE"
          },
          offers: {
            "@type": "Offer",
            url: "https://rainblock.net/shop",
            priceCurrency: "USD",
            price: "79.99",
            availability: "https://schema.org/InStock",
            itemCondition: "https://schema.org/NewCondition"
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4.9",
            reviewCount: "150"
          }
        }
      }]
    };
    t1 = <Script id="products-schema" type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(productsSchema)
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Navigation />;
    t3 = <RandomBackground />;
    t4 = <div aria-hidden={true} className="fixed inset-0 -z-10 bg-gradient-to-b from-black/75 via-black/25 to-black/10" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div aria-hidden={true} className="fixed inset-0 -z-10 pointer-events-none" style={{
      background: "radial-gradient(80% 60% at 50% 20%, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 100%)"
    }} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mb-3 text-xs font-extrabold uppercase tracking-[0.22em] text-gel-400/95 text-center">Premium Protection</div>;
    t7 = <h1 className="text-4xl font-extrabold leading-[1.05] tracking-tight md:text-5xl text-center">Shop Weatherproof Kits</h1>;
    t8 = <p className="mt-4 max-w-2xl mx-auto text-center text-white/75">Shop waterproof extension cord connector and weatherproof extension cord cover solutions for holiday lighting, decorations, and outdoor power.</p>;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <section className="pt-32 pb-10">{t6}{t7}{t8}<p className="mt-3 max-w-2xl mx-auto text-center text-white/80">New here? Start with the{" "}<Link href="/waterproof-extension-cord-connector" className="text-gel-400 underline hover:text-[#87dcff]">waterproof extension cord connector overview</Link>.</p><FeatureHighlightsStrip className="mt-6 mx-auto max-w-3xl" /></section>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="mb-5"><h2 className="text-2xl font-extrabold tracking-tight md:text-3xl">Why Choose Rain Block<sup className="tm-reg">®</sup>?</h2><p className="mt-2 max-w-2xl text-white/75">Trusted by thousands of customers for reliable outdoor electrical protection</p></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      title: "Waterproof Design",
      desc: "Advanced sealing technology prevents short circuits and water damage in any weather.",
      icon: <svg className="w-12 h-12 text-gel-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" /></svg>
    };
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      title: "Easy Installation",
      desc: "Simple snap-on design makes installation quick and hassle-free. No tools required.",
      icon: <svg className="w-12 h-12 text-gel-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <section className="py-10 md:py-14">{t10}<div className="grid gap-4 md:grid-cols-3">{[t11, t12, {
          title: "Durable & Reliable",
          desc: "Built for extreme weather with UV-resistant materials for long-lasting protection.",
          icon: <svg className="w-12 h-12 text-gel-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
        }].map(_temp5)}</div></section>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mb-6 rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-6"><h2 className="text-xl md:text-2xl font-extrabold tracking-tight">Waterproof extension cord connector protection</h2><p className="mt-2 max-w-3xl text-white/80">Use Rain Block® products to cover outdoor extension cord connections, keep Christmas light plugs dry, and reduce weather-related power interruptions.</p></div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="mb-5"><h2 className="text-2xl font-extrabold tracking-tight md:text-3xl">Available Products</h2><p className="mt-2 max-w-2xl text-white/75">Choose the perfect kit for your needs</p></div>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-6"><div id="product-component-1" /></div>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">{t16}<div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-6"><div id="product-component-2" /></div></div>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  let t19;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <h3 className="text-xl font-extrabold mb-2">Need Larger Quantities?</h3>;
    t19 = <p className="text-white/75 mb-4">Special pricing available for commercial projects and bulk orders</p>;
    $[18] = t18;
    $[19] = t19;
  } else {
    t18 = $[18];
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <section className="py-10 md:py-14">{t14}{t15}{t17}<div className="mt-8 rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-8 text-center">{t18}{t19}<Link href="/shop-bulk" className="inline-flex rounded-full btn-cta px-5 py-3 font-extrabold text-white transition-all duration-300" style={{
          textShadow: "none"
        }}>View Bulk Pricing</Link></div></section>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <h2 className="text-2xl font-extrabold tracking-tight md:text-3xl">Common Questions About Outdoor Plug Protection</h2>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  let t23;
  let t24;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div><h3 className="font-bold text-white">How do I protect extension cord connections from rain?</h3><p className="mt-1">Seal each exposed connection using a waterproof connector gasket and termination plug to keep water out.</p></div>;
    t23 = <div><h3 className="font-bold text-white">Do I need to cover outdoor Christmas light plugs?</h3><p className="mt-1">Yes. Covering open or connected plugs helps prevent moisture intrusion and nuisance trips during wet weather.</p></div>;
    t24 = <h3 className="font-bold text-white">Can Christmas light plugs get wet?</h3>;
    $[22] = t22;
    $[23] = t23;
    $[24] = t24;
  } else {
    t22 = $[22];
    t23 = $[23];
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <section className="py-8 md:py-10"><div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-6 md:p-8">{t21}<div className="mt-5 space-y-4 text-white/85">{t22}{t23}<div>{t24}<p className="mt-1">They can, but exposed connections are failure points. Follow our{" "}<Link href="/guides/how-to-weatherproof-christmas-lights-and-decorations" className="text-teal-300 hover:text-teal-200 underline">step-by-step weatherproof guide</Link>{" "}and use the right protection products.</p></div></div></div></section>;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  let t26;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <h2 className="text-2xl font-extrabold tracking-tight md:text-3xl">What Customers Say</h2>;
    $[26] = t26;
  } else {
    t26 = $[26];
  }
  let t27;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="mb-5">{t26}<p className="mt-2 max-w-2xl text-white/75">Real reviews from Rain Block<sup className="tm-reg">®</sup> users across the country</p></div>;
    $[27] = t27;
  } else {
    t27 = $[27];
  }
  let t28;
  let t29;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="w-10 h-10 bg-gel-400 rounded-full flex items-center justify-center mr-3"><span className="text-dark-900 font-semibold">B</span></div>;
    t29 = <p className="text-white font-medium">{"Brad & Nicole"}</p>;
    $[28] = t28;
    $[29] = t29;
  } else {
    t28 = $[28];
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-5 transition duration-300 ease-out transform-gpu will-change-transform hover:-translate-y-0.5 hover:brightness-110"><div className="flex items-center mb-3">{t28}<div>{t29}<div className="flex text-yellow-400 text-sm">{"\xE2\u02DC\u2026".repeat(5)}</div></div></div><p className="text-white font-semibold mb-2 text-sm">A must for outdoor holiday lights!</p><p className="text-white/60 text-xs mb-2">December 19, 2018 â€¢ Verified Purchase</p><p className="text-white/75 text-sm">I installed these on all my Holiday lights in my front yard, and 2 days later, it poured rain for another 2 days straight! So far, so good...with the Lights still on! Great customer service as well. Highly recommended!</p></div>;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  let t32;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="w-10 h-10 bg-gel-400 rounded-full flex items-center justify-center mr-3"><span className="text-dark-900 font-semibold">G</span></div>;
    t32 = <p className="text-white font-medium">Grace Miller</p>;
    $[31] = t31;
    $[32] = t32;
  } else {
    t31 = $[31];
    t32 = $[32];
  }
  let t33;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-5 transition duration-300 ease-out transform-gpu will-change-transform hover:-translate-y-0.5 hover:brightness-110"><div className="flex items-center mb-3">{t31}<div>{t32}<div className="flex text-yellow-400 text-sm">{"\xE2\u02DC\u2026".repeat(5)}</div></div></div><p className="text-white font-semibold mb-2 text-sm">These work so well!</p><p className="text-white/60 text-xs mb-2">January 9, 2019 â€¢ Verified Purchase</p><p className="text-white/75 text-sm">Our outdoor lights kept getting tripped because of the rain even though they were plugged into an outdoor outlet. We added these and we haven't had an issue since. So simple and effective. Highly recommend.</p></div>;
    $[33] = t33;
  } else {
    t33 = $[33];
  }
  let t34;
  let t35;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <div className="w-10 h-10 bg-gel-400 rounded-full flex items-center justify-center mr-3"><span className="text-dark-900 font-semibold">J</span></div>;
    t35 = <p className="text-white font-medium">James</p>;
    $[34] = t34;
    $[35] = t35;
  } else {
    t34 = $[34];
    t35 = $[35];
  }
  let t36;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-5 transition duration-300 ease-out transform-gpu will-change-transform hover:-translate-y-0.5 hover:brightness-110"><div className="flex items-center mb-3">{t34}<div>{t35}<div className="flex text-yellow-400 text-sm">{"\xE2\u02DC\u2026".repeat(5)}</div></div></div><p className="text-white font-semibold mb-2 text-sm">Worked as intended</p><p className="text-white/60 text-xs mb-2">January 17, 2019 â€¢ Verified Purchase</p><p className="text-white/75 text-sm">Worked great. Used these to keep Christmas lights and extension cords connections dry. Haven't had a problem yet here in Maine.</p></div>;
    $[36] = t36;
  } else {
    t36 = $[36];
  }
  let t37;
  let t38;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="w-10 h-10 bg-gel-400 rounded-full flex items-center justify-center mr-3"><span className="text-dark-900 font-semibold">B</span></div>;
    t38 = <p className="text-white font-medium">bigtruck</p>;
    $[37] = t37;
    $[38] = t38;
  } else {
    t37 = $[37];
    t38 = $[38];
  }
  let t39;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-5 transition duration-300 ease-out transform-gpu will-change-transform hover:-translate-y-0.5 hover:brightness-110"><div className="flex items-center mb-3">{t37}<div>{t38}<div className="flex text-yellow-400 text-sm">{"\xE2\u02DC\u2026".repeat(5)}</div></div></div><p className="text-white font-semibold mb-2 text-sm">Finally</p><p className="text-white/60 text-xs mb-2">December 16, 2018 â€¢ Verified Purchase</p><p className="text-white/75 text-sm">Terrific product, my Christmas lights stay on no matter what the weather is rain, snow whatever it doesn't matter.</p></div>;
    $[39] = t39;
  } else {
    t39 = $[39];
  }
  let t40;
  let t41;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <div className="w-10 h-10 bg-gel-400 rounded-full flex items-center justify-center mr-3"><span className="text-dark-900 font-semibold">D</span></div>;
    t41 = <p className="text-white font-medium">David L. Viale</p>;
    $[40] = t40;
    $[41] = t41;
  } else {
    t40 = $[40];
    t41 = $[41];
  }
  let t42;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-5 transition duration-300 ease-out transform-gpu will-change-transform hover:-translate-y-0.5 hover:brightness-110"><div className="flex items-center mb-3">{t40}<div>{t41}<div className="flex text-yellow-400 text-sm">{"\xE2\u02DC\u2026".repeat(5)}</div></div></div><p className="text-white font-semibold mb-2 text-sm">they work!!!</p><p className="text-white/60 text-xs mb-2">January 8, 2019 â€¢ Verified Purchase</p><p className="text-white/75 text-sm">I had no breaker trips with all of the rain we have had.</p></div>;
    $[42] = t42;
  } else {
    t42 = $[42];
  }
  let t43;
  let t44;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div className="w-10 h-10 bg-gel-400 rounded-full flex items-center justify-center mr-3"><span className="text-dark-900 font-semibold">H</span></div>;
    t44 = <p className="text-white font-medium">Happy Shopper</p>;
    $[43] = t43;
    $[44] = t44;
  } else {
    t43 = $[43];
    t44 = $[44];
  }
  let t45;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <section className="py-10 md:py-14">{t27}<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">{t30}{t33}{t36}{t39}{t42}<div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-5 transition duration-300 ease-out transform-gpu will-change-transform hover:-translate-y-0.5 hover:brightness-110"><div className="flex items-center mb-3">{t43}<div>{t44}<div className="flex text-yellow-400 text-sm">{"\xE2\u02DC\u2026".repeat(5)}</div></div></div><p className="text-white font-semibold mb-2 text-sm">These are wonderful and they do work!</p><p className="text-white/60 text-xs mb-2">October 9, 2018 â€¢ Verified Purchase</p><p className="text-white/75 text-sm">I have plug-in type landscape lights with extension cords covered by mulch. I was having problems with the GFI kicking the breaker when it rained a lot. I put these on wherever there was a plug connection and it has rained a lot since - no breaker kick-off!</p></div></div></section>;
    $[45] = t45;
  } else {
    t45 = $[45];
  }
  let t46;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <h2 className="text-2xl md:text-3xl font-extrabold mb-4">Need Help Choosing?</h2>;
    $[46] = t46;
  } else {
    t46 = $[46];
  }
  let t47;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <p className="text-white/75 text-lg mb-8 max-w-2xl mx-auto">Our team is here to help you find the perfect Rain Block<sup className="tm-reg">®</sup> solution for your needs.</p>;
    $[47] = t47;
  } else {
    t47 = $[47];
  }
  let t48;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <>{t1}<div className="min-h-screen relative text-white">{t2}{t3}{t4}{t5}<div className="relative z-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-20">{t9}{t13}{t20}{t25}{t45}<section className="py-10 md:py-14 pb-20"><div className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-8 md:p-12 text-center">{t46}{t47}<div className="flex flex-col sm:flex-row gap-4 justify-center"><Link href="/contact" className="rounded-full btn-cta px-5 py-3 font-extrabold text-white transition-all duration-300" style={{
                  textShadow: "none"
                }}>Contact Us</Link><Link href="/faq" className="rounded-full border border-white/20 bg-white/10 px-6 py-3 font-bold text-white hover:bg-white/15 transition-all duration-300">View FAQ</Link><Link href="/guides/how-to-weatherproof-christmas-lights-and-decorations" className="rounded-full border border-white/20 bg-white/10 px-6 py-3 font-bold text-white hover:bg-white/15 transition-all duration-300">How-To Guide</Link></div></div></section></div></div></>;
    $[48] = t48;
  } else {
    t48 = $[48];
  }
  return t48;
}
function _temp5(t0) {
  const {
    title,
    desc,
    icon
  } = t0;
  return <div key={title} className="rounded-2xl border border-white/10 bg-black/60 backdrop-blur-glass shadow-glass !bg-black/60 p-5 transition duration-300 ease-out transform-gpu will-change-transform hover:-translate-y-0.5 hover:brightness-110 hover:shadow-glass"><div className="mb-4">{icon}</div><div className="font-extrabold">{title}</div><div className="mt-2 text-sm text-white/75">{desc}</div></div>;
}
function _temp4() {
  const loadShopifyBuyButton = () => {
    const shopifyBuy = (globalThis as any).ShopifyBuy;
    if (shopifyBuy) {
      if (shopifyBuy.UI) {
        initShopifyBuyButton();
      } else {
        loadScript();
      }
    } else {
      loadScript();
    }
    function loadScript() {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";
      (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(script);
      script.onload = initShopifyBuyButton;
    }
  };
  function initShopifyBuyButton() {
    const shopify = (globalThis as any).ShopifyBuy;
    const client = shopify.buildClient({
      domain: SHOPIFY_CONFIG.domain,
      storefrontAccessToken: SHOPIFY_CONFIG.storefrontAccessToken
    });
    shopify.UI.onReady(client).then(_temp);
  }
  loadShopifyBuyButton();
  return _temp3;
}
function _temp3() {
  SHOPIFY_CONFIG.products.forEach(_temp2);
}
function _temp2(product_0) {
  const node_0 = document.getElementById(product_0.containerId);
  if (node_0) {
    node_0.innerHTML = "";
  }
}
function _temp(ui) {
  for (const product of SHOPIFY_CONFIG.products) {
    const node = document.getElementById(product.containerId);
    if (node && node.children.length === 0) {
      ui.createComponent("product", {
        id: [product.id],
        node,
        moneyFormat: "%24%7B%7Bamount%7D%7D",
        options: productOptions
      });
    }
  }
}